/**
 * linear Group
 * @param fb : FormBuilder
 */
export function linearGroup (fb: any): any {
    return fb.group({
        slope: [''],
        intercept: fb.group({
            currency: [''],
            amount: ['']
        })
    });
}